import {
  Component,
  OnInit,
  Inject,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

interface DeleteData {
  users: any;
  title: string;
  buttonText: string;
}

@Component({
  standalone: false,
  selector: 'app-confirm-delete-branch-dialog',
  templateUrl: './confirm-delete-branch-dialog.component.html',
  styleUrls: ['./confirm-delete-branch-dialog.component.scss']
})

export class ConfirmDeleteBranchDialogComponent implements OnInit {

  private paginator: MatPaginator;
  public buttonText = 'Delete';
  displayedColumns = ['name','sectorNumber','location'];
  dataSource = new MatTableDataSource();
  usersCount: number;
  @ViewChild(MatPaginator, {static: false}) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.dataSource.data = this.data.users;
    if (this.data.buttonText) {
      this.buttonText = this.data.buttonText;
    }
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
  }
}
